/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AdminService } from './services/AdminService';
import { AdresseService } from './services/AdresseService';
import { AssetsItemService } from './services/AssetsItemService';
import { AssetsItemCustomService } from './services/AssetsItemCustomService';
import { AssetsTypeService } from './services/AssetsTypeService';
import { AuthService } from './services/AuthService';
import { CalendarSyncIcsService } from './services/CalendarSyncIcsService';
import { CgvService } from './services/CgvService';
import { ClientService } from './services/ClientService';
import { CompanyImageService } from './services/CompanyImageService';
import { CustomerService } from './services/CustomerService';
import { DataCacheService } from './services/DataCacheService';
import { DevisConsultationService } from './services/DevisConsultationService';
import { DevisConsultationAdminService } from './services/DevisConsultationAdminService';
import { DriveService } from './services/DriveService';
import { DriveAdminService } from './services/DriveAdminService';
import { EquipeService } from './services/EquipeService';
import { FintectureCredentialsService } from './services/FintectureCredentialsService';
import { GeocodageService } from './services/GeocodageService';
import { GoogleReviewService } from './services/GoogleReviewService';
import { InterventionService } from './services/InterventionService';
import { InterventionFeedbackService } from './services/InterventionFeedbackService';
import { InvoicePaymentsService } from './services/InvoicePaymentsService';
import { InvoicePaymentsAdminService } from './services/InvoicePaymentsAdminService';
import { LolaProxyService } from './services/LolaProxyService';
import { MailTemplateService } from './services/MailTemplateService';
import { MailTemplateCustomerService } from './services/MailTemplateCustomerService';
import { ManifestService } from './services/ManifestService';
import { NatureRdvService } from './services/NatureRdvService';
import { PersonnelService } from './services/PersonnelService';
import { ProdevisEmailService } from './services/ProdevisEmailService';
import { ProdevisImportLogService } from './services/ProdevisImportLogService';
import { ProjetService } from './services/ProjetService';
import { PublicAccessService } from './services/PublicAccessService';
import { PublicSignatureService } from './services/PublicSignatureService';
import { QuoteService } from './services/QuoteService';
import { RankingService } from './services/RankingService';
import { RdvService } from './services/RdvService';
import { ReportService } from './services/ReportService';
import { ReportSubmissionService } from './services/ReportSubmissionService';
import { RoleService } from './services/RoleService';
import { SignatureLinkService } from './services/SignatureLinkService';
import { SmsService } from './services/SmsService';
import { SmtpSettingsService } from './services/SmtpSettingsService';
import { SpaceService } from './services/SpaceService';
import { SubscriptionService } from './services/SubscriptionService';
import { SuiviService } from './services/SuiviService';
import { TelescopeService } from './services/TelescopeService';
import { UrlShortenerService } from './services/UrlShortenerService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class AppClient {
    public readonly admin: AdminService;
    public readonly adresse: AdresseService;
    public readonly assetsItem: AssetsItemService;
    public readonly assetsItemCustom: AssetsItemCustomService;
    public readonly assetsType: AssetsTypeService;
    public readonly auth: AuthService;
    public readonly calendarSyncIcs: CalendarSyncIcsService;
    public readonly cgv: CgvService;
    public readonly client: ClientService;
    public readonly companyImage: CompanyImageService;
    public readonly customer: CustomerService;
    public readonly dataCache: DataCacheService;
    public readonly devisConsultation: DevisConsultationService;
    public readonly devisConsultationAdmin: DevisConsultationAdminService;
    public readonly drive: DriveService;
    public readonly driveAdmin: DriveAdminService;
    public readonly equipe: EquipeService;
    public readonly fintectureCredentials: FintectureCredentialsService;
    public readonly geocodage: GeocodageService;
    public readonly googleReview: GoogleReviewService;
    public readonly intervention: InterventionService;
    public readonly interventionFeedback: InterventionFeedbackService;
    public readonly invoicePayments: InvoicePaymentsService;
    public readonly invoicePaymentsAdmin: InvoicePaymentsAdminService;
    public readonly lolaProxy: LolaProxyService;
    public readonly mailTemplate: MailTemplateService;
    public readonly mailTemplateCustomer: MailTemplateCustomerService;
    public readonly manifest: ManifestService;
    public readonly natureRdv: NatureRdvService;
    public readonly personnel: PersonnelService;
    public readonly prodevisEmail: ProdevisEmailService;
    public readonly prodevisImportLog: ProdevisImportLogService;
    public readonly projet: ProjetService;
    public readonly publicAccess: PublicAccessService;
    public readonly publicSignature: PublicSignatureService;
    public readonly quote: QuoteService;
    public readonly ranking: RankingService;
    public readonly rdv: RdvService;
    public readonly report: ReportService;
    public readonly reportSubmission: ReportSubmissionService;
    public readonly role: RoleService;
    public readonly signatureLink: SignatureLinkService;
    public readonly sms: SmsService;
    public readonly smtpSettings: SmtpSettingsService;
    public readonly space: SpaceService;
    public readonly subscription: SubscriptionService;
    public readonly suivi: SuiviService;
    public readonly telescope: TelescopeService;
    public readonly urlShortener: UrlShortenerService;
    public readonly user: UserService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://api.test.lola-france.fr',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.admin = new AdminService(this.request);
        this.adresse = new AdresseService(this.request);
        this.assetsItem = new AssetsItemService(this.request);
        this.assetsItemCustom = new AssetsItemCustomService(this.request);
        this.assetsType = new AssetsTypeService(this.request);
        this.auth = new AuthService(this.request);
        this.calendarSyncIcs = new CalendarSyncIcsService(this.request);
        this.cgv = new CgvService(this.request);
        this.client = new ClientService(this.request);
        this.companyImage = new CompanyImageService(this.request);
        this.customer = new CustomerService(this.request);
        this.dataCache = new DataCacheService(this.request);
        this.devisConsultation = new DevisConsultationService(this.request);
        this.devisConsultationAdmin = new DevisConsultationAdminService(this.request);
        this.drive = new DriveService(this.request);
        this.driveAdmin = new DriveAdminService(this.request);
        this.equipe = new EquipeService(this.request);
        this.fintectureCredentials = new FintectureCredentialsService(this.request);
        this.geocodage = new GeocodageService(this.request);
        this.googleReview = new GoogleReviewService(this.request);
        this.intervention = new InterventionService(this.request);
        this.interventionFeedback = new InterventionFeedbackService(this.request);
        this.invoicePayments = new InvoicePaymentsService(this.request);
        this.invoicePaymentsAdmin = new InvoicePaymentsAdminService(this.request);
        this.lolaProxy = new LolaProxyService(this.request);
        this.mailTemplate = new MailTemplateService(this.request);
        this.mailTemplateCustomer = new MailTemplateCustomerService(this.request);
        this.manifest = new ManifestService(this.request);
        this.natureRdv = new NatureRdvService(this.request);
        this.personnel = new PersonnelService(this.request);
        this.prodevisEmail = new ProdevisEmailService(this.request);
        this.prodevisImportLog = new ProdevisImportLogService(this.request);
        this.projet = new ProjetService(this.request);
        this.publicAccess = new PublicAccessService(this.request);
        this.publicSignature = new PublicSignatureService(this.request);
        this.quote = new QuoteService(this.request);
        this.ranking = new RankingService(this.request);
        this.rdv = new RdvService(this.request);
        this.report = new ReportService(this.request);
        this.reportSubmission = new ReportSubmissionService(this.request);
        this.role = new RoleService(this.request);
        this.signatureLink = new SignatureLinkService(this.request);
        this.sms = new SmsService(this.request);
        this.smtpSettings = new SmtpSettingsService(this.request);
        this.space = new SpaceService(this.request);
        this.subscription = new SubscriptionService(this.request);
        this.suivi = new SuiviService(this.request);
        this.telescope = new TelescopeService(this.request);
        this.urlShortener = new UrlShortenerService(this.request);
        this.user = new UserService(this.request);
    }
}

